import { Head, usePage } from '@inertiajs/react';

type SeoHeadProps = {
    title: string;
    description: string;
    image?: string;
    type?: 'website' | 'article';
};

export default function SeoHead({
    title,
    description,
    image,
    type = 'website',
}: SeoHeadProps) {
    const { url } = usePage();
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const canonical = origin ? `${origin}${url}` : url;
    const twitterCard = image ? 'summary_large_image' : 'summary';

    return (
        <Head title={title}>
            <meta name="description" content={description} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content={type} />
            {canonical && <meta property="og:url" content={canonical} />}
            {image && <meta property="og:image" content={image} />}
            <meta name="twitter:card" content={twitterCard} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            {image && <meta name="twitter:image" content={image} />}
            {canonical && <link rel="canonical" href={canonical} />}
        </Head>
    );
}


